import {
  getString,
  getInt32,
} from "@surya-digital/leo-ts-types";

export interface FileAttributesDTO {
  sha256: string;
  name: string;
  size: number;
}

export class FileAttributes {
  readonly isFileAttributesFileAttributes: boolean = true;

  readonly sha256: string;
  readonly name: string;
  readonly size: number;

  static readonly constraints = {
    "sha256": {
      "minSize": 64,
      "maxSize": 64,
      
      
      
      
    },
    "name": {
      "minSize": 1,
      "maxSize": 500,
      
      
      
      
    },
    "size": {
      "minValue": 20,
      "maxValue": 250000000,
    }
  }

  constructor(
  sha256: string, 
  name: string, 
  size: number
  ) {
    FileAttributes.validateSha256(sha256);
    this.sha256 = sha256;
    FileAttributes.validateName(name);
    this.name = name;
    FileAttributes.validateSize(size);
    this.size = size;
  }

  static fromDTO(dto: FileAttributesDTO): FileAttributes {
    const sha256 = getString(dto, "sha256", InvalidFileAttributesSha256Error);
    const name = getString(dto, "name", InvalidFileAttributesNameError);
    const size = getInt32(dto, "size", InvalidFileAttributesSizeError);
    return new FileAttributes(
      sha256,
      name,
      size
    );
  }

  toDTO(): FileAttributesDTO {
    const dto: FileAttributesDTO = {
        sha256: this.sha256,
        name: this.name,
        size: this.size
    };
    return dto;
  }
  private static validateSha256 = (sha256: string): void => {
    if(sha256.length < 64) {
      throw new InvalidFileAttributesSha256MinSizeError(
        64,
        `Attribute sha256 is too short. Size is ${sha256.length}. Min size is 64.`
      );
    }
    if(sha256.length > 64) {
      throw new InvalidFileAttributesSha256MaxSizeError(
        64,
        `Attribute sha256 is too long. Size is ${sha256.length}. Max size is 64.`
      );
    }
      if(sha256.trim().length === 0) {
        throw new InvalidFileAttributesSha256NonEmptyError(
          `Attribute sha256 cannot be an empty string.`
        );
      }
  }
  private static validateName = (name: string): void => {
    if(name.length < 1) {
      throw new InvalidFileAttributesNameMinSizeError(
        1,
        `Attribute name is too short. Size is ${name.length}. Min size is 1.`
      );
    }
    if(name.length > 500) {
      throw new InvalidFileAttributesNameMaxSizeError(
        500,
        `Attribute name is too long. Size is ${name.length}. Max size is 500.`
      );
    }
      if(name.trim().length === 0) {
        throw new InvalidFileAttributesNameNonEmptyError(
          `Attribute name cannot be an empty string.`
        );
      }
  }
  private static validateSize = (size: number): void => {
    if(size < 20) {
      throw new InvalidFileAttributesSizeMinValueError(
        20,
        `Attribute size has value ${size}. Min value is 20.`
      );
    }
    if(size > 250000000) {
      throw new InvalidFileAttributesSizeMaxValueError(
        250000000,
        `Attribute size has value ${size}. Max value is 250000000.`
      );
    }
  }
  
}

FileAttributes.prototype.toString = function toString(): string {
  return `FileAttributes(sha256='${this.sha256}',name='${this.name}',size='${this.size}')`;
};

export class InvalidFileAttributesError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidFileAttributesError";
  }
}
export class InvalidFileAttributesSha256Error extends InvalidFileAttributesError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidFileAttributesSha256Error";
  }
}

export class InvalidFileAttributesSha256MaxSizeError extends InvalidFileAttributesSha256Error {
  readonly maxSize: number;
  constructor(maxSize: number, message?: string) {
    super(message);
    this.maxSize = maxSize;
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidFileAttributesSha256MaxSizeError";
  }
}

export class InvalidFileAttributesSha256MinSizeError extends InvalidFileAttributesSha256Error {
  readonly minSize: number;
  constructor(minSize: number, message?: string) {
    super(message);
    this.minSize = minSize;
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidFileAttributesSha256MinSizeError";
  }
}

export class InvalidFileAttributesSha256NonEmptyError extends InvalidFileAttributesSha256Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidFileAttributesSha256NonEmptyError";
  }
}

export class InvalidFileAttributesNameError extends InvalidFileAttributesError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidFileAttributesNameError";
  }
}

export class InvalidFileAttributesNameMaxSizeError extends InvalidFileAttributesNameError {
  readonly maxSize: number;
  constructor(maxSize: number, message?: string) {
    super(message);
    this.maxSize = maxSize;
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidFileAttributesNameMaxSizeError";
  }
}

export class InvalidFileAttributesNameMinSizeError extends InvalidFileAttributesNameError {
  readonly minSize: number;
  constructor(minSize: number, message?: string) {
    super(message);
    this.minSize = minSize;
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidFileAttributesNameMinSizeError";
  }
}

export class InvalidFileAttributesNameNonEmptyError extends InvalidFileAttributesNameError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidFileAttributesNameNonEmptyError";
  }
}

export class InvalidFileAttributesSizeError extends InvalidFileAttributesError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidFileAttributesSizeError";
  }
}

export class InvalidFileAttributesSizeMaxValueError extends InvalidFileAttributesSizeError {
  readonly maxValue: number;
  constructor(maxValue: number, message?: string) {
    super(message);
    this.maxValue = maxValue;
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidFileAttributesSizeMaxValueError";
  }
}

export class InvalidFileAttributesSizeMinValueError extends InvalidFileAttributesSizeError {
  readonly minValue: number;
  constructor(minValue: number, message?: string) {
    super(message);
    this.minValue = minValue;
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidFileAttributesSizeMinValueError";
  }
}
